// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3125":"b9b3a095","5157":"fdf38d43","6490":"f1abe75e"}[chunkId] + ".chunk.css";
};